import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import "../../assets/css/--component-account-notification.css";
import { getCustomerNotificationPreferences, getNotificationPreferences, postCustomerNotificationPreferences } from "../../helper/backend-methods";

const NotificationPage = () => {
  const [notifications, setNotifications] = useState({
    Email: false,
    SMS: false,
    Offers: false
  });
  const [notificationData, setNotificationData] = useState([]);
  const [loading, setLoading] = useState(true);


  const handleToggle = (notificationType) => {
     let updatedNotifications = { ...notifications };
     updatedNotifications[notificationType] = !updatedNotifications[notificationType];
     setNotifications(updatedNotifications);
    _updateCustomerNotificationPreferences({ emailNotifications: updatedNotifications.Email, smsNotifications: updatedNotifications.SMS, specialOffers: updatedNotifications.Offers })
  };

  const getNotificationPreferencesList = () => {
    getNotificationPreferences().then(({ data }) => {
      if (data.Status) {
        setNotificationData(data.Data);
      }
      setLoading(false)
    }).catch((e) => {
      console.log(e);
      setLoading(false)
    })
  }

  const _updateCustomerNotificationPreferences = (params) => {
    postCustomerNotificationPreferences(params).then(({ data }) => {
      if (data.Status) {
        // Handle success if needed
      } else {
        // Handle failure if needed
      }
    });
  };

  const _getCustomerNotificationPreferences = () => {
    getCustomerNotificationPreferences().then(({ data }) => {
      if (data.Status) {
        setNotifications({
          Email: data.Data.Email,
          SMS: data.Data.SMS,
          Offers: data.Data.Offers
        });
      }
      setLoading(false)
    }).catch((e) => {
      console.log(e);
      setLoading(false)
    })
  }

  useEffect(() => {
    getNotificationPreferencesList();
    _getCustomerNotificationPreferences();
  }, []);
  // const notificationData = [
  //   {
  //     id: 1,
  //     type: "emailNotifications",
  //     title: "Email Notifications",
  //     description: "Receive order confirmations and updates via email",
  //     icon: "ri-mail-line"
  //   },
  //   {
  //     id: 2,
  //     type: "smsNotifications",
  //     title: "SMS Notifications",
  //     description: "Get text message alerts for order status",
  //     icon: "ri-chat-1-line"
  //   },
  //   {
  //     id: 3,
  //     type: "specialOffers",
  //     title: "Special Offers",
  //     description: "Receive notifications about promotions and deals",
  //     icon: "ri-gift-line"
  //   }
  // ];

  return (
    <section id="notification-section" className="mt-5 ms-4">
      <div>
        <h1 className="fs-30 text-blakish fw-600 mt-0 mb-0">Notification Preferences</h1>
        <span className="separator my-3" />
      </div>

      <Row>
        {notificationData.map((notification) => (
          <Col key={notification.Id} md={12} className="mb-4">
            <Card className="notification-card">
              <div className="notification-card-body">
                <div className="notification-content">
                  {/* <div className="notification-icon">
                    <i className={notification.icon}></i>
                  </div> */}
                  <div className="notification-info">
                    <h5 className="notification-title">{notification.Title}</h5>
                    <p className="notification-description">{notification.Description}</p>
                  </div>
                </div>

                <div className="notification-toggle">
                  <Form>
                    <FormGroup switch className="mb-0">
                      <Input
                        type="switch"
                        checked={notifications[notification.Type]}
                        onChange={() => handleToggle(notification.Type)}
                        className="notification-switch"
                      />
                      {/* <Label check className="toggle-label">
                        {notifications[notification.type] ? "ON" : "OFF"}
                      </Label> */}
                    </FormGroup>
                  </Form>
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </section>
  );
};

export default NotificationPage;